import { render, staticRenderFns } from "./AuctionsCardMobile.vue?vue&type=template&id=1e4a8e4f&scoped=true&"
import script from "./AuctionsCardMobile.vue?vue&type=script&lang=js&"
export * from "./AuctionsCardMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4a8e4f",
  null
  
)

export default component.exports